var DataRow = /** @class */ (function () {
    function DataRow(columns, values) {
        this.columns = columns;
        this.values = values;
    }
    DataRow.prototype.toArray = function () {
        return Array.from(this.values);
    };
    DataRow.prototype.size = function () {
        return this.values.length;
    };
    DataRow.prototype.getValue = function (colIdOrIndex) {
        var index;
        if (typeof colIdOrIndex === "string") {
            index = this.columns.getIndex(colIdOrIndex);
            if (index === undefined) {
                throw new RangeError("No column with id '" + colIdOrIndex + "'");
            }
        }
        else {
            index = colIdOrIndex;
        }
        if (index >= this.values.length)
            throw new RangeError("Out of range: " + index);
        return this.values[index];
    };
    DataRow.prototype.setValue = function (colIdOrIndex, value) {
        var index;
        if (typeof colIdOrIndex === "string") {
            index = this.columns.getIndex(colIdOrIndex);
            if (index === undefined) {
                throw new RangeError("No column with id '" + colIdOrIndex + "'");
            }
        }
        else {
            index = colIdOrIndex;
        }
        if (index >= this.values.length)
            throw new RangeError("Out of range: " + index);
        this.values[index] = value;
    };
    return DataRow;
}());
export { DataRow };
//# sourceMappingURL=data_row.js.map